module.exports = __webpack_public_path__ + "04c547e5c70f862ca624b41ca553a7f4.jpg";